import { Directive, ElementRef, Input, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Directive({
	selector: '[smoothScroll]'
})
export class SmoothScrollDirective {
	@Input('smoothScroll') scrollToId: string;
	@Input() scrollDuration: number = 250;
	@Input() buffer: number = 75;

	@HostListener('click', ['$event']) onclick(event: Event) {
		event.preventDefault();
		this.scrollTo(this.scrollToId);
	}

	slashRegex: RegExp = /\//g;
	targetId: string;
	constructor(
		private router: Router,
		private hostRoute: ActivatedRoute,
		private hostEl: ElementRef,
		private location: Location
	) {}

	scrollTo(id: string) {
		const scrollEl = id.match(this.slashRegex)
			? document.getElementById(
					id
						.split(this.slashRegex)
						.pop()
						.slice(1)
			  )
			: document.getElementById(id.slice(1));

		if (scrollEl) {
			const scrollElTop = window.pageYOffset + scrollEl.getBoundingClientRect().top;
			// if the window is scrolled less than the top of the target
			const direction = window.pageYOffset <= scrollElTop ? 'down' : 'up';
			// distance to be covered if down is the top of the element - how far we've already scrolled
			const distance = direction === 'down' ? scrollElTop - window.pageYOffset : window.pageYOffset - scrollElTop;

			// grab end time based on current time and duration
			const endTime = new Date().getTime() + this.scrollDuration;

			// start animation
			this.scrollAnimation(scrollElTop, endTime, direction, distance);
		}
	}

	scrollAnimation(to: number, endTime: number, direction: 'up' | 'down', distance: number) {
		const currentTime = new Date().getTime();

		// calculate the new scroll position based on current time
		let scrollPos = ((endTime - currentTime) / this.scrollDuration) * distance;
		scrollPos =
			direction === 'down' ? window.pageYOffset + (distance - scrollPos) : window.pageYOffset - (distance - scrollPos);

		// if the scroll position goes too far or is equal to the end value, set it to the end value
		if (
			(direction === 'down' && scrollPos >= to - this.buffer) ||
			(direction === 'up' && scrollPos <= to - this.buffer)
		) {
			scrollPos = to - this.buffer;
			window.scrollTo(0, scrollPos);

			// set the hash in the url
			if (this.scrollToId && this.scrollToId !== '#app') {
				const route = this.hostRoute.routeConfig ? ['./'] : [this.location.path()];
				this.router.navigate(route, {
					queryParamsHandling: 'preserve',
					relativeTo: this.hostRoute,
					fragment: this.scrollToId.split('#').reverse()[0]
				});
			}
		} else {
			// if the scroll position hasn't reached the end value, continue the animation
			window.scrollTo(0, scrollPos);

			// set animation frame function to continue if scroll position has not reached its end value
			const animationFrameFn = this.scrollAnimation.bind(this, ...arguments);
			const newFrameDown = direction === 'down' && window.pageYOffset < to;
			const newFrameUp = direction === 'up' && window.pageYOffset > to && window.pageYOffset !== 0;

			if (newFrameDown || newFrameUp) {
				requestAnimationFrame(animationFrameFn);
			}
		}
	}
}
